module.exports = __webpack_public_path__ + "img/banner4.2172ea02.png";